// Localisations proposées pour France Travail. Chaque DOM a son propre compte France Travail
// côté worker (FRANCE_TRAVAIL_COMPTEn_*) ; null = compte par défaut.
export const LOCATION_OPTIONS = [
  { value: 'france', label: 'France', account: null },
  { value: 'mayotte', label: 'Mayotte', account: 'compte1' },
  { value: 'guadeloupe', label: 'Guadeloupe', account: 'compte2' },
  { value: 'reunion', label: 'La Réunion', account: 'compte3' },
  { value: 'guyane', label: 'Guyane', account: 'compte4' },
  { value: 'martinique', label: 'Martinique', account: 'compte5' },
  { value: 'autre', label: 'Autre', account: null },
]

export function getFranceTravailAccount(locationType) {
  const locationOption = LOCATION_OPTIONS.find((opt) => opt.value === locationType)
  return locationOption?.account || null
}

// Nombre de candidats par recherche (le plafond est aussi imposé par l'API).
export const SEARCH_DEFAULT_PROFILES = 20
export const SEARCH_MAX_PROFILES = 50
export const SEARCH_CREDIT_COST = 10
